<template>
  <Container type="card-full">
    <!-- <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div> -->
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">表名</div>
          <div class="field">
            <el-input v-model="query.tablecode" :maxlength="20" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">表说明</div>
          <div class="field">
            <el-input v-model="query.tablename" :maxlength="20" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid :list="list" flexname="" :cols="cols"
      :showfooter="false" :showPage="true" :resizable="true"
      :total="query.total" @cellClick="cellClick" @pagechange="pagechange"
      :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
    <el-dialog :title="table.tableid ? '修改' : '新增'" :visible.sync="tableform">
      <el-form class="small-space" :model="table" label-position="left" label-width="70px" ref="ruleForm" style='width: 400px; margin-left:50px;'>
        <el-form-item label="代号" required>
          <el-input v-model="table.tablecode" :maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="名称" required>
          <el-input v-model="table.tablename" :maxlength="40" show-word-limit></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button @click="tableform = false">关闭</el-button>
      </div>
    </el-dialog>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn.vue"
  import vggrid from '../common/vggrid'
  export default {
    name: 'tableIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btn:{},
        cols: [
          { type: 'index', title: '行号',calculExpr:'', width: 80 },
          { field: 'tablecode', title: '表名',calculExpr:'', addNewRowFlg: false},
          { field: 'tablename', title: '表说明',calculExpr:'',addNewRowFlg: false},
        ],
        options: [{ label: '字符型', value: 'C' },{ label: '长整型', value: 'L' },{ label: '短整型', value: 'N' },{ label: '字节型', value: 'B' },{ label: '日期型', value: 'D' },{ label: '日期时间', value: 'T' }],
        tableform: false,
        table: {},
        query: {
          tablename: '',
          tablecode: '',
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('ADD', () => this.addTable())
      this.$on('CHG', () => this.chgTable())
      this.$on('DEL', () => this.delTable())
      this.$on('FIELD', () => this.fieldList())
      this.$on('TKEY', () => this.tableKey())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.getTableList()
    },
    mounted () {
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.table = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async addTable () {
        this.table = {}
        this.tableform = true
      },
      async chgTable () {
        this.tableform = true
      },
      async fieldList () {
        console.log(this.table, '000')
        this.$router.push({name: 'fieldList', params: {form: this.table}})
      },
      async tableKey () {
        this.$router.push({name: 'tablekey', params: {form: this.table}})
      },
      async delTable () {
        console.log(this.table)
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/kfgl/table/delTable',
            method: "post",
            data: this.table
          })
          if (data.issuccess===1) {
            this.getTableList()
            this.$message.success(data.msg)
          }
        })
      },
      // search (target) {},
      async save () {
        await request({
          url: '/kfgl/table/addOrEdit',
          method: "post",
          data: this.table
        })
        this.$message.success('操作成功')
        this.tableform = false
        if (!this.table.tableid) {
          this.query.currPage = 1
        }
        await this.getTableList()
      },
      async cellClick (row) {
        this.table = row.row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getTableList()
      },
      search () {
        this.query.offset = 0
        this.getTableList()
      },
      async getTableList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/kfgl/table/getTableList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
  }
</script>
<style lang="scss">

</style>
